import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { AppUrls } from '../../routing/app-urls';
import { StoreManager } from '../store/store.manager';

export const authGuard: CanActivateFn = async (_route, state) => {
    const authService = inject(AuthenticationService);
    const router = inject(Router);
    const storeManager = inject(StoreManager);

    const isValid = await authService.isSessionValid();

    if (isValid) {
        return true;
    }

    storeManager.resetState();

    return router.createUrlTree(['/', AppUrls.signInUrl], { queryParams: { returnUrl: state.url } });
};
